/* sk-lb-homepage.js — Startseite: langen SEO-Text einklappen (Texte aus data-Attributen des Script-Tags,
   übersetzt über sk.hp.read_more_text / sk.hp.read_less_text). Redesign 2026-09-25: Hero-Stempel/-Akzent entfernt
   (alte Slideshow ist durch sections/sk-hp-hero.liquid ersetzt). */
(function () {
  if (!document.body.classList.contains('template-index')) return;
  var script = document.currentScript;
  var MORE = (script && script.dataset.more) || 'Mehr lesen';
  var LESS = (script && script.dataset.less) || 'Weniger anzeigen';

  function init() {
    document.querySelectorAll('.shopify-section.rich-text--section').forEach(function (section) {
      var content = section.querySelector('.rich-text-content, .rte');
      if (!content || section.hasAttribute('data-hp-collapsible')) return;
      var isLong = content.querySelectorAll('p').length >= 3 || content.textContent.length > 600;
      if (!isLong) return;
      section.setAttribute('data-hp-collapsible', '1');
      var btn = document.createElement('button');
      btn.className = 'hp-readmore-btn';
      btn.type = 'button';
      btn.textContent = MORE;
      btn.setAttribute('aria-expanded', 'false');
      content.parentNode.insertBefore(btn, content.nextSibling);
      btn.addEventListener('click', function () {
        var expanded = section.classList.toggle('is-expanded');
        btn.textContent = expanded ? LESS : MORE;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
